import { useEffect } from 'react';
import { useUploadAssetApi } from '../../../../api/upload-asset';
import { notifyUploadSuccess, notifyUploadError, notifyUploadLoading } from '../components/ToastNotifications';

interface UseAssetUploadProps {
  account_id: string;
  platform: string;
  user_id: string;
  onSuccess?: () => void;
}

export const useAssetUpload = ({ account_id, platform, user_id, onSuccess }: UseAssetUploadProps) => {
  const uploadAssetApi = useUploadAssetApi();

  const handleUpload = (ad_id: string, s3_url: string, type: string) => {
    const fileType = type.includes('image') ? 'image' : 'video';

    const payload = {
      account_id,
      platform,
      ad_id,
      user_id,
      s3_url,
      visual_type: fileType,
    };

    uploadAssetApi.uploadAsset(payload);
  };

  useEffect(() => {
    if (uploadAssetApi.data) {
      notifyUploadSuccess(onSuccess);
    }
  }, [uploadAssetApi.data, onSuccess]);

  useEffect(() => {
    if (uploadAssetApi.error) {
      notifyUploadError();
    }
  }, [uploadAssetApi.error]);

  useEffect(() => {
    if (uploadAssetApi.loading) {
      notifyUploadLoading();
    }
  }, [uploadAssetApi.loading]);

  return {
    handleUpload,
    loading: uploadAssetApi.loading,
    error: uploadAssetApi.error,
    data: uploadAssetApi.data,
  };
}; 